import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../contexts/UserContext";

export default function PendingApprovalPage() {
    const user = useUserContext();
    const navigate = useNavigate();

    // RN-257: 承認待ちが増えるため、承認後に F5（読み込み直し）だけで使い始められるようにする。
    // 読み込み時の状態が承認待ち以外なら、入口（/check-status）で行き先を決め直す
    useEffect(() => {
        if (user.loading) return;
        if (user.status && user.status !== "pending") {
            navigate("/check-status", { replace: true });
        }
    }, [user.loading, user.status, navigate]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center">
            <h2 className="text-xl mb-4">承認待ちです</h2>
            <p className="mb-2 text-slate-600">
                管理者があなたのアカウントを承認するまでお待ちください。
            </p>
            <p className="mb-6 text-sm text-slate-500">
                承認されたら、下の「承認されたか確かめる」を押すと利用を始められます。
            </p>

            <button
                onClick={() => {
                    // 入口から開き直し、最新の状態で行き先を決め直す
                    window.location.href = "/check-status";
                }}
                className="mb-3 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
                承認されたか確かめる
            </button>

            <button
                onClick={() => {
                    localStorage.clear();
                    window.location.href = "/";
                }}
                className="px-4 py-2 bg-red-500 text-white rounded"
            >
                ログアウト
            </button>
        </div>
    )
}
